import React, { useCallback, useContext, useRef, useState } from "react";
import PropTypes from "prop-types";
import { HStack, Heading, Image, Text, VStack } from "native-base";
import { FiDownload } from "react-icons/fi";
import moment from "moment";
import html2canvas from "html2canvas";
import colors from "../../constants/colors";
import Itinerary from "../itinerary";
import { StatusContext } from "../../contexts";
import logo from "../../assets/images/logo.png";

function DownloadItineraryButton(props) {
  const { id, disabled, itinerary } = props;
  const container = useRef();
  const status = useContext(StatusContext);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const onDownloadQuotation = useCallback(async () => {
    try {
      setIsDownloading(true);
      const canvas = await html2canvas(container.current);
      const imgData = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = imgData;
      a.download = `itinerary_${id}_${moment().format("Y_MM_DD_HH_mm_ss")}.png`;
      a.click();
      a.remove();
    } catch (error) {
      status.updateErrorMessage(error);
    }
    setIsDownloading(false);
  }, [id, status]);

  return (
    <HStack alignItems="flex-start">
      <button
        onClick={onDownloadQuotation}
        disabled={disabled || isDownloading || !isImageLoaded}>
        <HStack
          backgroundColor={colors.third}
          paddingX={5}
          paddingY={2}
          borderRadius="md"
          space={3}>
          <FiDownload color={colors.white} size={20} />
          <Text color={colors.white}>Descargar</Text>
        </HStack>
      </button>
      <VStack
        ref={container}
        padding={5}
        width="100vw"
        space={5}
        position="absolute"
        left="50vw"
        maxWidth={500}>
        <HStack space={3}>
          <Image
            src={logo}
            alt="logo"
            height={60}
            width={200}
            onLoadEnd={() => setIsImageLoaded(true)}
          />
          <Heading flex={1}>Tour #{id}</Heading>
        </HStack>
        <Itinerary detailed itinerary={itinerary} />
      </VStack>
    </HStack>
  );
}

DownloadItineraryButton.propTypes = {
  id: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  itinerary: PropTypes.array.isRequired,
};

DownloadItineraryButton.defaultProps = {
  disabled: false,
};

export default React.memo(DownloadItineraryButton);
